import { createIcon } from './createIcon';

/**
 * Bordered rectangle with a divider — the sidebar itself. Used by both the
 * top bar's toggle and the sidebar's own collapse button, so the action reads
 * the same wherever the layout puts it.
 */
export const SidebarIcon = createIcon({
  name: 'SidebarIcon',
  viewBox: '0 0 24 24',
  size: 16,
  children: (
    <>
      <rect
        x="3"
        y="4"
        width="18"
        height="16"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="9"
        y1="4"
        x2="9"
        y2="20"
        stroke="currentColor"
        strokeWidth="2"
      />
    </>
  ),
});

export default SidebarIcon;
